{
  "hero": {
    "title": "快速開始",
    "description": "依角色分成三個區塊，逐步說明平台上實際的操作流程。想先快速了解平台是什麼，可以先看系統介紹。"
  },
  "roleNav": {
    "label": "選擇角色"
  },
  "step": "STEP {{number}}",
  "roles": {
    "student": {
      "title": "參賽者",
      "description": "從報名到查看結果，參賽者端的完整操作流程。",
      "manualCta": "NAPAICP 參賽者操作手冊",
      "steps": {
        "signIn": {
          "title": "註冊或登入",
          "description": "以電子郵件註冊帳號並完成信箱驗證，之後即可用密碼登入平台。"
        },
        "team": {
          "title": "建立或加入隊伍",
          "description": "自行建立隊伍，或使用隊長提供的邀請連結加入既有隊伍；一位參賽者同一場競賽僅能加入一支隊伍。"
        },
        "form": {
          "title": "填寫報名與作品表單",
          "description": "依競賽指定的表單欄位填寫報名資訊：報名表單會自動儲存，必填欄位都填妥並儲存成功後，報名資料即視為已送出，截止前可隨時修改；若之後顯示「需補填」，請補上缺少的欄位。作品繳交表單則是先存成草稿，確認後需「標記為就緒」並「正式提交」。"
        },
        "submit": {
          "title": "上傳並正式提交作品",
          "description": "檔案透過短效簽名連結直接上傳至私有儲存空間；確認無誤後正式提交，提交後的版本會被凍結保存，無法再原地修改。"
        },
        "results": {
          "title": "追蹤評分與結果",
          "description": "競賽公布結果後，可在隊伍頁面查看成績與名次；若賽制設有決賽，入圍名單也會在此通知。"
        },
        "events": {
          "title": "使用活動服務（選用）",
          "description": "參加研討會等活動時，從主導覽「活動」進入活動頁：可只用 Email 預約免費接駁車（含最多 3 位同行者）並取得乘車 QR、回覆午餐與宴會、向服務台送出案件。詳見參賽者操作手冊的活動服務。"
        }
      }
    },
    "judge": {
      "title": "評審",
      "description": "從查看指派到送出評分的完整操作流程。",
      "manualCta": "NAPAICP 評審操作手冊",
      "steps": {
        "signIn": {
          "title": "登入評審帳號",
          "description": "主辦方以 Email 送出評審邀請：若該信箱已有帳號，以既有帳號登入後，在「總覽」頁的「待回覆的評審邀請」按「接受邀請」（或「婉拒」）即可取得評審身分；若尚無帳號，系統會自動建立帳號並寄送一次性臨時密碼，第一次登入後須立即設定新密碼。"
        },
        "assignments": {
          "title": "查看指派清單",
          "description": "指派清單只會顯示作品的匿名代碼，看不到隊伍或參賽者的真實身分，確保評分過程公正。"
        },
        "score": {
          "title": "依評分表逐項打分",
          "description": "依主辦方設定的評分表項目逐一評分，每一項都必須在指定範圍內填寫分數。"
        },
        "submitScore": {
          "title": "送出評分",
          "description": "確認所有項目都已完成後送出評分；送出後會被鎖定，如需修改須由主辦方協助重新開放。"
        },
        "events": {
          "title": "活動服務與評審身分無關（選用）",
          "description": "活動頁的接駁車、餐飲與客服只需登入並驗證 Email 即可使用，不影響評審身分與評分；活動資料與競賽評分資料分開保存。"
        }
      }
    },
    "admin": {
      "title": "主辦方",
      "description": "從建立競賽到公布結果的完整操作流程。",
      "manualCta": "NAPAICP 主辦方操作手冊",
      "steps": {
        "createCompetition": {
          "title": "建立競賽並設定時程",
          "description": "透過建置精靈建立新競賽，設定報名、繳交與評審時程；若賽制含初賽與決賽，可另外設定兩個階段。"
        },
        "formsCategories": {
          "title": "設計表單與組別",
          "description": "建立報名表單、作品繳交表單，並依需要設定參賽組別；表單發布後仍保留版本歷史。"
        },
        "rubricJudges": {
          "title": "建立評分表並指派評審",
          "description": "設計評分項目與配分，將評審帳號指派到對應的作品，並可設定評審迴避名單。"
        },
        "calculateResults": {
          "title": "計算、鎖定並公布結果",
          "description": "評分完成後計算成績、視需要人工覆核獎項等第，鎖定並公布結果；每次調整皆留有稽核紀錄。"
        },
        "announce": {
          "title": "發布公告與通知參賽者",
          "description": "在後台「營運」分組的「公告」頁發布公告，顯示在公開頁與參賽者的「競賽資訊」頁；需要時可勾選「同時寄 Email 通知」，依角色、類別、輪次或報名欄位選擇收件人。寄出前會顯示人數與信件預覽，也可先寄測試信給自己；已寄出的 Email 無法收回。"
        },
        "events": {
          "title": "活動現場營運（選用）",
          "description": "活動成員（Owner、Manager、Scanner、Viewer）由活動 Owner 在 /events/:slug/admin 管理；現場以接駁車驗票頁掃描乘車 QR，可離線暫存再同步，並以乘客名單人工核對。競賽主辦權限不會自動成為活動權限。"
        }
      }
    }
  },
  "helpCenterCta": {
    "heading": "想搜尋特定操作或錯誤訊息？",
    "description": "前往說明中心，用關鍵字快速找到你需要的答案。"
  },
  "cta": {
    "heading": "準備好開始了嗎？",
    "description": "登入後平台會依你的角色帶你到對應的區域。",
    "action": "立即登入",
    "aboutCta": "系統介紹",
    "architectureCta": "技術架構"
  },
  "adminGuide": {
    "heading": "平台管理員嗎？",
    "description": "查看完整的 NAPAICP 競賽平台管理操作手冊，內含平台與競賽管理介面的逐項說明。",
    "action": "NAPAICP 平台管理操作手冊"
  },
  "manuals": {
    "heading": "完整操作手冊",
    "description": "依角色查看完整的操作手冊：",
    "student": "NAPAICP 參賽者操作手冊",
    "judge": "NAPAICP 評審操作手冊",
    "organizer": "NAPAICP 主辦方操作手冊",
    "admin": "NAPAICP 平台管理操作手冊"
  }
}
